import { trackFrontendEvent } from './tracking';

const clientEventId = () => {
  if (typeof window !== 'undefined' && window.crypto?.randomUUID) {
    return window.crypto.randomUUID();
  }

  return `${Date.now()}-${Math.random().toString(16).slice(2)}`;
};

export const trackPaywallEvent = (event, metadata = {}) => {
  if (!event) return;

  const payload = {
    ...metadata,
    client_event_id: clientEventId(),
    occurred_at: new Date().toISOString(),
    source: 'web',
  };

  if (typeof window !== 'undefined') {
    payload.page_path = `${window.location.pathname}${window.location.search}${window.location.hash}`;
    payload.referrer = document.referrer || undefined;
  }

  trackFrontendEvent(event, payload);

  if (typeof fetch !== 'function') return;

  fetch('/paywall_events', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'same-origin',
    body: JSON.stringify({
      event,
      ...payload,
    }),
  }).catch(() => {});
};
